<div [class]="overlayClass"
     (click)="onEditClick()">
  <div class="edit-overlay-content">
    <div class="edit-overlay-bg">
      <ng-content></ng-content>
    </div>
  </div>
  <button class="fa fa-pencil"
          (click)="onEditClick()"></button>
</div>
